var _circle, _circle2, _g, _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGovernemnt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#79B6FC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2947_2455",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#79B6FC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2947_2455)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5 41.5L8 31L32 15L41.5 21L42.5 26.5L34 37L26.5 41.5Z",
    fill: "#338BEF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 6L32 15H8L20 6Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 6L32 15H20V6Z",
    fill: "#EDECED"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 15,
    width: 24,
    height: 2,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 15,
    width: 12,
    height: 2,
    fill: "#EDECED"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 29,
    width: 24,
    height: 2,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 29,
    width: 12,
    height: 2,
    fill: "#EDECED"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 27,
    width: 21,
    height: 2,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 27,
    width: 11,
    height: 2,
    fill: "#EDECED"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 17,
    width: 16,
    height: 10,
    fill: "#3C3567"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 17,
    width: 8,
    height: 10,
    fill: "#585092"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 17,
    width: 4,
    height: 1,
    fill: "#EDECED"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 18,
    width: 2,
    height: 9,
    fill: "#EDECED"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 15.5,
    y: 17,
    width: 4,
    height: 1,
    fill: "#EDECED"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 18,
    width: 2,
    height: 9,
    fill: "#EDECED"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 17,
    width: 4,
    height: 1,
    fill: "#EDECED"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 18,
    width: 2,
    height: 9,
    fill: "#EDECED"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 25.5,
    y: 17,
    width: 4,
    height: 1,
    fill: "#EDECED"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 18,
    width: 2,
    height: 9,
    fill: "#EDECED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGovernemnt);
export default __webpack_public_path__ + "static/media/Governemnt.cdc0053d99c0e49ae3525b305a049e7f.svg";
export { ForwardRef as ReactComponent };